import { Component, FormEvent } from 'react';

import { debounce } from 'lodash-es';
import { InjectedIntl, injectIntl } from 'react-intl';

import SearchField from 'src/components/search-field';
import { SearchFieldAligner } from 'src/components/search-field.style';

import i18n from './search-filter.i18n';

export type Props = {
  search: string | null | undefined;
  onFilterChange: (filter: { search: string }) => void;
  intl: InjectedIntl;
};

export type State = {
  currentSearch: string | null | undefined;
  lastSearch: string | null | undefined;
};

export const DEBOUNCE_DELAY = 300;

export class SearchFilter extends Component<Props, State> {
  state = {
    currentSearch: this.props.search,
    lastSearch: this.props.search,
  };

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (nextProps.search !== prevState.lastSearch) {
      return {
        currentSearch: nextProps.search,
        lastSearch: nextProps.search,
      };
    }

    return null;
  }

  notifyFilterChanged = (search: string) => {
    this.props.onFilterChange({ search });
  };

  debouncedFilterValueHandler = debounce(
    this.notifyFilterChanged,
    DEBOUNCE_DELAY
  );

  // @ts-ignore TODO: fix noImplicitAny error here
  handleFilterChange = (e: FormEvent<HTMLInputElement>) => {
    const currentSearch: string = e.currentTarget.value;

    this.setState({ currentSearch });
    this.debouncedFilterValueHandler(currentSearch);
  };

  clearFilter = () => {
    const currentSearch = '';
    this.setState({ currentSearch });
    this.notifyFilterChanged(currentSearch);
  };

  render() {
    return (
      <SearchFieldAligner>
        <SearchField
          currentSearch={this.state.currentSearch}
          handleFilterChange={this.handleFilterChange}
          placeholder={this.props.intl.formatMessage(i18n.placeholder)}
          clearFilter={this.clearFilter}
          fieldName="search-repository-input"
        />
      </SearchFieldAligner>
    );
  }
}

export default injectIntl(SearchFilter);
